<main id="gratuity_list" class="info">
    <header>
        <header-component></header-component>
        <div class="nav">
            <h1>{{ _(app.gratuity.texts.title)}}</h1>
            <span class="icon back" @click="app.setPage('Terminal')"
                >chevron_left</span
            >
        </div>
    </header>

    <section class="main">
        <gratuity-carousel
            v-if="pickedUpImagesInGeneral.length"
            :hasArrowButton="true"
            :images="pickedUpImagesInGeneral"
            :clickable="true"
            :lang="app.getLang()"
            @setGratuityStaff="setGratuityStaff"
        >
        </gratuity-carousel>
        <template>
            <div class="information">
                <span>{{ _(app.gratuity.texts.description)}}</span>
                <div v-for="staff in app.gratuity.staffs">
                    <div>
                        <img
                            v-if="staff.image_urls.length > 0"
                            :src="staff.image_urls[0]"
                        />
                        <div class="information__name">
                            {{ _(staff.texts.staff_name)}}
                        </div>
                        <div class="information__description">
                            {{ _(staff.texts.staff_description)}}
                        </div>
                        <button
                            class="information__button"
                            @click="setGratuityStaff(staff.id)"
                        >
                            {{_(app.gratuity.texts.select_button)}}
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </section>

    <template v-if="app.gratuity.texts.notice[app.getLang()].length > 0">
        <hr />
        <div class="pulldown_column">
            <section class="remarks">
                <pre>{{ _(app.gratuity.texts.notice) }}</pre>
            </section>
        </div>
    </template>

    <tab-bar :page="app.query.page"></tab-bar>
</main>
